import Offline from './offline';

export default Offline;
